import './style.scss'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FiSmartphone } from 'react-icons/fi'
import utility from 'src/utils/utility'
import {
    Card, Button, Text, Flex, Box, tokens,
} from 'src/componentv2'
import { PAGE_PADDING_X, fontMedium } from 'src/model/v2/interface/constants'

interface MockBuild {
    platform: 'iOS' | 'Android'
    version: string
    status: 'Not generated' | 'Generating' | 'Ready' | 'Failed'
    lastGenerated: string | null
}

const MOCK_BUILDS: MockBuild[] = [
    { platform: 'Android', version: '1.0.0', status: 'Ready', lastGenerated: 'Jul 12, 2026' },
    { platform: 'iOS', version: '1.0.0', status: 'Not generated', lastGenerated: null },
]

const STATUS_STYLES: Record<string, { bg: string; color: string }> = {
    Ready: { bg: '#ECFDF3', color: '#027A48' },
    Generating: { bg: '#FFFAEB', color: '#B54708' },
    Failed: { bg: '#FEF3F2', color: '#B42318' },
    'Not generated': { bg: '#F2F4F7', color: '#667085' },
}

const AppGenerationPage = () => {
    const navigate = useNavigate()
    const [appName] = useState('First National Bank')
    const [packageId] = useState('com.firstnational.mobile')
    const [builds] = useState<MockBuild[]>(MOCK_BUILDS)
    const [isGenerating, setIsGenerating] = useState(false)

    const handleGenerate = (platform: string) => {
        setIsGenerating(true)
        setTimeout(() => setIsGenerating(false), 1200)
    }

    return (
        <div className="app-generation-page" style={{ padding: `2.4rem ${PAGE_PADDING_X}` }}>
            <Card topMargin="2" padding="3.2" radius="1.2">
                <Flex items="center" gap="1.2">
                    <Box
                        width="4" height="4" radius="0.8"
                        bgColor="#EFF8FF"
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <FiSmartphone size={18} color="#1570EF" />
                    </Box>
                    <Box>
                        <Text fontSize="1.6" style={fontMedium} color={tokens.textDark}>
                            App Details
                        </Text>
                    </Box>
                </Flex>

                <div className="form-row" style={{ marginTop: '2rem' }}>
                    <Box>
                        <Text fontSize="1.3" color={tokens.textMuted}>App Name</Text>
                        <Text fontSize="1.4" topMargin="0.4">{appName}</Text>
                    </Box>
                    <Box>
                        <Text fontSize="1.3" color={tokens.textMuted}>Package ID</Text>
                        <Text fontSize="1.4" topMargin="0.4">{packageId}</Text>
                    </Box>
                </div>
            </Card>

            <Text topMargin="3.2" fontSize="1.8" style={fontMedium} className="app-generation-subsection">
                Builds
            </Text>

            <Box topMargin="1.6" className="app-generation-list">
                {builds.map((build) => {
                    const s = STATUS_STYLES[build.status]
                    return (
                        <Card key={build.platform} padding="2.4" radius="1.2" topMargin="1.2">
                            <Flex justify="space-between" items="center">
                                <Box>
                                    <Text fontSize="1.6" style={fontMedium} color={tokens.textDark}>
                                        {build.platform}
                                    </Text>
                                    <Text fontSize="1.4" color={tokens.textMuted} topMargin="0.2">
                                        Version {build.version}
                                        {build.lastGenerated ? ` · Last generated ${build.lastGenerated}` : ''}
                                    </Text>
                                </Box>

                                <Flex items="center" gap="1.2">
                                    <span
                                        style={{
                                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                            borderRadius: 999, padding: '0.2rem 1rem',
                                            fontSize: '1.2rem', fontWeight: 600,
                                            background: s.bg, color: s.color,
                                        }}
                                    >
                                        {build.status}
                                    </span>

                                    <Button
                                        variant="outline"
                                        size="sm"
                                        disabled={isGenerating}
                                        onClick={() => handleGenerate(build.platform)}
                                    >
                                        {isGenerating ? 'Generating...' : 'Generate'}
                                    </Button>
                                </Flex>
                            </Flex>
                        </Card>
                    )
                })}
            </Box>
        </div>
    )
}

export default utility.routeData('app-generation', 'App Generation', <AppGenerationPage />)